
import React from "react";

const ArticleSkeleton = () => {
  return (
    <div className="article-skeleton-card">
      <div className="skeleton skeleton-image" />

      <div className="skeleton-content">
        <div className="skeleton skeleton-title" />
        <div className="skeleton skeleton-category" />
        <div className="skeleton skeleton-description" />
        <div className="skeleton skeleton-description short" />
        <div className="skeleton skeleton-date" />
      </div>

      <div className="skeleton skeleton-divider" />
    </div>
  );
};

export default ArticleSkeleton;
